import { Component, ErrorInfo } from "react";

import ErrorPage from "components/common/pages/ErrorPage";
import { ErrorLoggerContext, Logger } from "providers/ErrorLogger";
import { recoverFromChunkError } from "utils/chunkReload";

interface Props {
  children?: React.ReactNode;
}

interface State {
  error: Error | null;
}

export default class ErrorBoundaryBase extends Component<Props, State> {
  static contextType = ErrorLoggerContext;

  constructor(props: Props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // A caught chunk-load error is a stale cached bundle, not a real app
    // crash — reload once to pull the current bundle instead of showing the
    // error page. No-ops if it isn't a chunk error or we've already reloaded.
    if (recoverFromChunkError(error.message)) return;

    const { logger } = this.context as { logger?: Logger };

    if (logger)
      logger.error(
        `${error.message}\nComponent stack: ${info.componentStack ?? "unknown"}`,
        error
      );
  }

  render() {
    if (this.state.error) return <ErrorPage />;

    return this.props.children;
  }
}
